// Lógica compartilhada pra manter o cadastro de Clientes/Veículos em dia a partir de
// uma tela de documento (Contratos, Procuração, Documentos Complementares): comparar
// os dados preenchidos na tela com o que já está no cadastro, e localizar um registro
// existente por CPF/CNPJ ou placa antes de criar um novo (evita duplicidade).
import axios from 'axios';
import config from '../config/config';
import { variantesDePlaca } from './leituraVeiculo';

// A comparação com o cadastro é pura e vive em comparacaoCadastro.js; reexportada aqui para quem já a importava
export { normalizar, camposDiferentes, situacaoCadastro } from './comparacaoCadastro';

const { API_BASE_URL } = config;

function apenasDigitos(v) {
  return (v || '').toString().replace(/\D/g, '');
}

function authHeader() {
  const token = localStorage.getItem('jwtToken');
  return { headers: { Authorization: `Bearer ${token}` } };
}

// Cliente do cadastro com este CPF/CNPJ (ou null)
export async function buscarClientePorDocumento(documento) {
  try {
    const response = await axios.get(`${API_BASE_URL}/clientes/cpfcnpj/${apenasDigitos(documento)}`, authHeader());
    return response.data && response.data.idCliente ? response.data : null;
  } catch (err) {
    return null;
  }
}

// Veículo do cadastro com esta placa (ou null). A busca no backend é por igualdade exata, então tenta
// todas as formas em que a placa pode estar gravada: com e sem hífen, e também no outro padrão
// (ABC-1234 acha um veículo cadastrado como ABC-1C34, e vice-versa) — senão o mesmo veículo seria
// cadastrado duas vezes, uma por padrão de placa.
export async function buscarVeiculoPorPlaca(placa) {
  const digitada = (placa || '').trim().toUpperCase();
  const variantes = variantesDePlaca(digitada);
  for (const variante of (variantes.length ? variantes : [digitada])) {
    try {
      const response = await axios.get(`${API_BASE_URL}/veiculos/placa/${encodeURIComponent(variante)}`, authHeader());
      if (response.data && response.data.idVeiculo) return response.data;
    } catch (err) {
      // tenta a próxima variante
    }
  }
  return null;
}

// Veículo do cadastro com este chassi (ou null). O chassi identifica o veículo mesmo quando a placa
// mudou, e é o único identificador de um veículo cadastrado sem placa.
export async function buscarVeiculoPorChassi(chassi) {
  const limpo = (chassi || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (!limpo) return null;
  try {
    const response = await axios.get(`${API_BASE_URL}/veiculos/chassi/${encodeURIComponent(limpo)}`, authHeader());
    return response.data && response.data.idVeiculo ? response.data : null;
  } catch (err) {
    return null;
  }
}

// O veículo do documento, procurado por tudo que o identifica: a placa (em qualquer padrão), a placa
// anterior impressa no CRLV, e o chassi. Só assim um veículo reemplacado, ou cadastrado sem placa,
// é encontrado em vez de virar um cadastro duplicado.
export async function buscarVeiculoDoDocumento({ placa, placaAnterior, chassi }) {
  return (placa && await buscarVeiculoPorPlaca(placa))
    || (placaAnterior && await buscarVeiculoPorPlaca(placaAnterior))
    || (chassi && await buscarVeiculoPorChassi(chassi))
    || null;
}
